import { CommunicationChatEventsApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useCommunicationChatEventsApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new CommunicationChatEventsApi(configuration),
    [configuration]
  );
};
